import * as captchaTypes from '../types/Captcha';
import {INITIAL_STATE} from './state/Captcha';
import {PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE,PAGE_GO_TO_START_PAGE, PAGE_GO_TO_CREATE_COMPLAINT_PAGE, PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR} from '../types/Page';
import {COMPLAINT_ISSUE_COMPLAINT_FAILURE} from '../types/Complaint';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case captchaTypes.GET_CAPTCHA_SITE_KEY_SUCCESS:
            return {
                ...state,
                captchaSiteKey: action.payload
            };
        case captchaTypes.VALIDATE_CAPTCHA_RESULT_SUCCESS:
            return {
                ...state,
                isCaptchaValid: action.payload
            };
        case PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case PAGE_GO_TO_START_PAGE: 
        case PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
        case COMPLAINT_ISSUE_COMPLAINT_FAILURE:
        case PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
            return {
                ...state,
                isCaptchaValid: false
            };
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Captcha.js